export default __webpack_public_path__ + "static/media/no-data-concept-illustration_114360-536.e8669aa6.jpg";